import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { CircularProgress } from '../../../common'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'
import MyBookingsHandler from '../../../containers/MyBookingsHandler'
import MenuHeader from '../../../containers/MenuHeader'

import * as Constants from '../../../../helpers/Constants'
import * as Strings from './strings'
import * as laundryBookingActions from '../../../../actions/LaundryBookings'
import * as configActions from '../../../../actions/Config'
import * as offlineModeActions from '../../../../actions/OfflineMode'

class MyBookings extends Component {
  componentWillMount() {
    const { history, user, offlineMode, config, data } = this.props

    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.laundrySystemFetched) {
      this.props.tryGetLaundrySystem(user.token, config.language, (h, i, t, b) => this.props.showAlert(h, i, t, b))
    }
  }

  getLaundryName(laundryId) {
    const { data } = this.props

    for (let i = 0; i < data.laundries.length; i++) {
      if (data.laundries[i].id.toString() === laundryId.toString()) {
        return data.laundries[i].name
      }
    }

    return ''
  }

  getMyBookings() {
    const { data, config, user, laundryBookings, offlineMode } = this.props
    const bookings = []

    data.laundryTimes.forEach(time => {
      time.bookings.forEach(booking => {
        if (
          booking.apartment &&
          booking.apartment.id === data.apartment.id
        ) {
          bookings.push({
            id: booking.id,
            date: booking.date,
            time: time.startTime + '-' + time.endTime,
            title:
              Strings.default.LAUNDRY[data.laundryRules.laundryType][
                config.language
              ] +
              ' ' +
              this.getLaundryName(booking.laundryId),
            isDeleting: laundryBookings.isDeleting.indexOf(booking.id) !== -1,
            deleteBooking: () =>
              this.props.tryDeleteBooking(
                user.token,
                booking.id,
                config.language,
                (h, i, t, b) => this.props.showAlert(h, i, t, b),
                offlineMode
              )
          })
        }
      })
    })

    return bookings
  }

  renderContent() {
    const { user, data, config } = this.props

    if (!user.fetched || !data.laundrySystemFetched) {
      return <CircularProgress />
    }

    const myBookings = this.getMyBookings()

    return (
      <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <MyBookingsHandler
            items={myBookings}
            title={Strings.default.MY_LAUNDRY_BOOKINGS[config.language]}
          />
      </div>
    )
  }

  render() {
    const { history, user, offlineMode, config } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    return (
      <MenuHeader
        history={history}
        header={Strings.default.MY_LAUNDRY_BOOKINGS[config.language]}
        selected={Constants.MY_BOOKINGS_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

function mapStateToProps({ user, data, config, laundryBookings }) {
  return { user, data, config, laundryBookings }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...laundryBookingActions,
      ...offlineModeActions,
      ...configActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBookings)



// WEBPACK FOOTER //
// ./src/components/pages/laundries/MyBookings/index.js